// ----- Imports -----

// Logos
import lightLogo from '../img/logo/lightVersion.png';
import darkLogo from '../img/logo/darkVersion.png';

// Backgrounds
import codeBackground from '../img/background/blueprintBG.png';
import blueprintBackground from '../img/background/codeBG.png';

// Dash Out | Oct 01, 2021
import dashout from '../img/dash-out/dashout.png';
import low_dashout from '../img/dash-out/low-dashout.png';

import dashout_screenshot1 from '../img/dash-out/Screenshot (1).png';
import dashout_screenshot2 from '../img/dash-out/Screenshot (2).png';
import dashout_screenshot3 from '../img/dash-out/Screenshot (3).png';

// Aregon | Oct 03, 2022
import aregon from '../img/aregon/aregon.png';
import low_aregon from '../img/aregon/low-aregon.png';

import aregon_screenshot1 from '../img/aregon/Screenshot (1).png';
import aregon_screenshot2 from '../img/aregon/Screenshot (2).png';
import aregon_screenshot3 from '../img/aregon/Screenshot (3).png';
import aregon_screenshot4 from '../img/aregon/Screenshot (4).png';
import aregon_screenshot5 from '../img/aregon/Screenshot (5).png';

// Equanimity Travel | Jan 06, 2023
import equanimity from '../img/equanimity/equanimity.png';
import low_equanimity from '../img/equanimity/low-equanimity.png';

import equanimity_screenshot1 from '../img/equanimity/Screenshot (1).png';
import equanimity_screenshot2 from '../img/equanimity/Screenshot (2).png';
import equanimity_screenshot3 from '../img/equanimity/Screenshot (3).png';
import equanimity_screenshot4 from '../img/equanimity/Screenshot (4).png';

// Myosotis Memories | Jan 14, 2023
import myosotis from '../img/myosotis/myosotis.png';
import low_myosotis from '../img/myosotis/low-myosotis.png';

import myosotis_screenshot1 from '../img/myosotis/Screenshot (1).png';
import myosotis_screenshot2 from '../img/myosotis/Screenshot (2).png';
import myosotis_screenshot3 from '../img/myosotis/Screenshot (3).png';
import myosotis_screenshot4 from '../img/myosotis/Screenshot (4).png';
import myosotis_screenshot5 from '../img/myosotis/Screenshot (5).png';

// Misaryes: Subnebula | Apr 17, 2023
import misaryes from '../img/misaryes/misaryes.png';
import low_misaryes from '../img/misaryes/low-misaryes.png';

import misaryes_screenshot1 from '../img/misaryes/Screenshot (1).png';
import misaryes_screenshot2 from '../img/misaryes/Screenshot (2).png';
import misaryes_screenshot3 from '../img/misaryes/Screenshot (3).png';
import misaryes_screenshot4 from '../img/misaryes/Screenshot (4).png';
import misaryes_screenshot5 from '../img/misaryes/Screenshot (5).png';
import misaryes_screenshot6 from '../img/misaryes/Screenshot (6).png';
import misaryes_screenshot7 from '../img/misaryes/Screenshot (7).png';
import misaryes_screenshot8 from '../img/misaryes/Screenshot (8).png';
import misaryes_screenshot9 from '../img/misaryes/Screenshot (9).png';

// Unity Procedural Generation Tool V1 | Aug 15, 2023
import dungen from '../img/dungen-generation-tool/Dungen.png';

import dungen_screenshot1 from '../img/dungen-generation-tool/Screenshot (1).png';
import dungen_screenshot2 from '../img/dungen-generation-tool/Screenshot (2).png';
import dungen_screenshot3 from '../img/dungen-generation-tool/Screenshot (3).png';
import dungen_screenshot4 from '../img/dungen-generation-tool/Screenshot (4).png';
import dungen_screenshot5 from '../img/dungen-generation-tool/Screenshot (5).png';
import dungen_screenshot6 from '../img/dungen-generation-tool/Screenshot (6).png';


// Cult-Tuerie | Jan 14, 2024
import culttuerie from '../img/cult-tuerie/culttuerie.png';
import low_culttuerie from '../img/cult-tuerie/low-culttuerie.png';

import culttuerie_screenshot1 from '../img/cult-tuerie/Screenshot (1).png';
import culttuerie_screenshot2 from '../img/cult-tuerie/Screenshot (2).png';
import culttuerie_screenshot3 from '../img/cult-tuerie/Screenshot (3).png';
import culttuerie_screenshot4 from '../img/cult-tuerie/Screenshot (4).png';
import culttuerie_screenshot5 from '../img/cult-tuerie/Screenshot (5).png';
import culttuerie_screenshot6 from '../img/cult-tuerie/Screenshot (6).png';

// Wizard in Montreal - Game Jam Version | Jan 12, 2025
import wizardMontreal from '../img/wizard-in-montreal/wizard-in-montreal.png';
// import low_wizardMontreal from '../img/wizard-in-montreal/low-wizard-in-montreal.png';

import wizardMontrealGameJam_screenshot1 from '../img/wizard-in-montreal/game-jam-version/Screenshot (1).png';
import wizardMontrealGameJam_screenshot2 from '../img/wizard-in-montreal/game-jam-version/Screenshot (2).png';
import wizardMontrealGameJam_screenshot3 from '../img/wizard-in-montreal/game-jam-version/Screenshot (3).png';
import wizardMontrealGameJam_screenshot4 from '../img/wizard-in-montreal/game-jam-version/Screenshot (4).png';
import wizardMontrealGameJam_screenshot5 from '../img/wizard-in-montreal/game-jam-version/Screenshot (5).png';
import wizardMontrealGameJam_screenshot6 from '../img/wizard-in-montreal/game-jam-version/Screenshot (6).png';


// Wizard in Montreal | Aug 05, 2025
import wizardMontreal_screenshot1 from '../img/wizard-in-montreal/Screenshot (1).jpg';
import wizardMontreal_screenshot2 from '../img/wizard-in-montreal/Screenshot (2).png';
import wizardMontreal_screenshot3 from '../img/wizard-in-montreal/Screenshot (3).png';
import wizardMontreal_screenshot4 from '../img/wizard-in-montreal/Screenshot (4).jpg';
import wizardMontreal_screenshot5 from '../img/wizard-in-montreal/Screenshot (5).jpg';
import wizardMontreal_screenshot6 from '../img/wizard-in-montreal/Screenshot (6).jpg';


// IMPolite Guests | Mar 09, 2026
import impoliteGuests from '../img/IMPolite-guests/IMPoliteGuests.png';
// import low_impoliteGuests from '../img/IMPolite-guests/low-IMPoliteGuests.png';

import impoliteGuests_screenshot1 from '../img/IMPolite-guests/Screenshot (1).jpg';
import impoliteGuests_screenshot2 from '../img/IMPolite-guests/Screenshot (2).jpg';
import impoliteGuests_screenshot3 from '../img/IMPolite-guests/Screenshot (3).jpg';
import impoliteGuests_screenshot4 from '../img/IMPolite-guests/Screenshot (4).png';
import impoliteGuests_screenshot5 from '../img/IMPolite-guests/Screenshot (5).png';


// All About Moo | May 03, 2026
import allAboutMoo from '../img/all-about-moo/All-About-Moo.png';
// import low_allAboutMoo from '../img/all-about-moo/low-All-About-Moo.png';

import allAboutMoo_heatmaps from '../img/all-about-moo/heatmaps.png';
import allAboutMoo_screenshot1 from '../img/all-about-moo/Screenshot (1).png';
import allAboutMoo_screenshot2 from '../img/all-about-moo/Screenshot (2).png';
import allAboutMoo_screenshot3 from '../img/all-about-moo/Screenshot (3).png';
import allAboutMoo_screenshot4 from '../img/all-about-moo/Screenshot (4).png';
import allAboutMoo_screenshot5 from '../img/all-about-moo/Screenshot (5).png';
import allAboutMoo_screenshot6 from '../img/all-about-moo/Screenshot (6).png';



// Sly n' Ky: Jouet 2 en 1 | May 10, 2026
import slynky from '../img/sly-n-ky/SlyNKy.png';
// import low_slynky from '../img/sly-n-ky/low-SlyNKy.png';

import slynky_screenshot1 from '../img/sly-n-ky/gameplay (1).gif';
import slynky_screenshot2 from '../img/sly-n-ky/gameplay (2).gif';
import slynky_screenshot3 from '../img/sly-n-ky/gameplay (3).gif';
import slynky_screenshot4 from '../img/sly-n-ky/gameplay (4).gif';
import slynky_screenshot5 from '../img/sly-n-ky/gameplay (5).gif';
import slynky_screenshot6 from '../img/sly-n-ky/gameplay (6).gif';
import slynky_screenshot7 from '../img/sly-n-ky/gameplay (7).gif';
import slynky_screenshot8 from '../img/sly-n-ky/gameplay (8).gif';
import slynky_screenshot9 from '../img/sly-n-ky/gameplay (9).gif';


// World Making Tool | Aug 23, 2026
import worldMakingTool from '../img/world-making-tool/world-making-tool.png';

import worldMakingTool_screenshot1 from '../img/world-making-tool/Screenshot (1).png';
import worldMakingTool_screenshot2 from '../img/world-making-tool/Screenshot (2).png';
import worldMakingTool_screenshot3 from '../img/world-making-tool/Screenshot (3).png';
import worldMakingTool_screenshot4 from '../img/world-making-tool/Screenshot (4).png';
import worldMakingTool_screenshot5 from '../img/world-making-tool/Screenshot (5).png';
import worldMakingTool_screenshot6 from '../img/world-making-tool/Screenshot (6).png';
import worldMakingTool_screenshot7 from '../img/world-making-tool/Screenshot (7).png';
import worldMakingTool_screenshot8 from '../img/world-making-tool/Screenshot (8).png';
import worldMakingTool_screenshot9 from '../img/world-making-tool/Screenshot (9).png';


// Perseids | Current Project

// Other projects imports would go here


// ----- Exports -----

// Logo exports
export const logos = {
  light: lightLogo,
  dark: darkLogo
}

// Background exports
export const backgrounds = {
  aboutTopRight: codeBackground,
  aboutBottomLeft: blueprintBackground
}

// Dash Out exports
export const dashoutImages = {
  high: dashout,
  low: low_dashout,
  screenshots: [
    dashout_screenshot1,
    dashout_screenshot2,
    dashout_screenshot3
  ]
}

// Aregon exports
export const aregonImages = {
  high: aregon,
  low: low_aregon,
  screenshots: [
    aregon_screenshot1,
    aregon_screenshot2,
    aregon_screenshot3,
    aregon_screenshot4,
    aregon_screenshot5
  ]
}

// Equanimity Travel exports
export const equanimityImages = {
  high: equanimity,
  low: low_equanimity,
  screenshots: [
    equanimity_screenshot1,
    equanimity_screenshot2,
    equanimity_screenshot3,
    equanimity_screenshot4
  ]
}

// Myosotis Memories exports
export const myosotisImages = {
  high: myosotis,
  low: low_myosotis,
  screenshots: [
    myosotis_screenshot1,
    myosotis_screenshot2,
    myosotis_screenshot3,
    myosotis_screenshot4,
    myosotis_screenshot5
  ]
}

// Misaryes: Subnebula exports
export const misaryesImages = {
  high: misaryes,
  low: low_misaryes,
  screenshots: [
    misaryes_screenshot1,
    misaryes_screenshot2,
    misaryes_screenshot3,
    misaryes_screenshot4,
    misaryes_screenshot5,
    misaryes_screenshot6,
    misaryes_screenshot7,
    misaryes_screenshot8,
    misaryes_screenshot9
  ]
}

// Dungen: Unity Procedural Generation Tool V1 exports
export const dungenImages = {
  high: dungen,
  low: dungen,
  screenshots: [
    dungen_screenshot1,
    dungen_screenshot2,
    dungen_screenshot3,
    dungen_screenshot4,
    dungen_screenshot5,
    dungen_screenshot6
  ]
}

// Cult-Tuerie exports
export const culttuerieImages = {
  high: culttuerie,
  low: low_culttuerie,
  screenshots: [
    culttuerie_screenshot1,
    culttuerie_screenshot2,
    culttuerie_screenshot3,
    culttuerie_screenshot4,
    culttuerie_screenshot5,
    culttuerie_screenshot6
  ]
}


// Wizard in Montreal - Game Jam Version exports
export const wizardMontrealGameJamImages = {
  high: wizardMontreal,
  low: wizardMontreal,
  screenshots: [
    wizardMontrealGameJam_screenshot1,
    wizardMontrealGameJam_screenshot2,
    wizardMontrealGameJam_screenshot3,
    wizardMontrealGameJam_screenshot4,
    wizardMontrealGameJam_screenshot5,
    wizardMontrealGameJam_screenshot6
  ]
}

// Wizard in Montreal exports
export const wizardMontrealImages = {
  high: wizardMontreal,
  low: wizardMontreal,
  screenshots: [
    wizardMontreal_screenshot1,
    wizardMontreal_screenshot2,
    wizardMontreal_screenshot3,
    wizardMontreal_screenshot4,
    wizardMontreal_screenshot5,
    wizardMontreal_screenshot6
  ]
}

// IMPolite Guests exports
export const impoliteGuestsImages = {
  high: impoliteGuests,
  low: impoliteGuests,
  screenshots: [
    impoliteGuests_screenshot1,
    impoliteGuests_screenshot2,
    impoliteGuests_screenshot3,
    impoliteGuests_screenshot4,
    impoliteGuests_screenshot5
  ]
}

// All About Moo exports
export const allAboutMooImages = {
  high: allAboutMoo,
  low: allAboutMoo,
  screenshots: [
    allAboutMoo_heatmaps,
    allAboutMoo_screenshot1,
    allAboutMoo_screenshot2,
    allAboutMoo_screenshot3,
    allAboutMoo_screenshot4,
    allAboutMoo_screenshot5,
    allAboutMoo_screenshot6
  ]
}

// Sly n' Ky: Jouet 2 en 1 exports
export const slynkyImages = {
  high: slynky,
  low: slynky,
  screenshots: [
    slynky_screenshot1,
    slynky_screenshot2,
    slynky_screenshot3,
    slynky_screenshot4,
    slynky_screenshot5,
    slynky_screenshot6,
    slynky_screenshot7,
    slynky_screenshot8,
    slynky_screenshot9
  ]
}

// World Making Tool exports
export const worldMakingToolImages = {
  high: worldMakingTool,
  low: worldMakingTool,
  screenshots: [
    worldMakingTool_screenshot1,
    worldMakingTool_screenshot2,
    worldMakingTool_screenshot3,
    worldMakingTool_screenshot4,
    worldMakingTool_screenshot5,
    worldMakingTool_screenshot6,
    worldMakingTool_screenshot7,
    worldMakingTool_screenshot8,
    worldMakingTool_screenshot9
  ]
}

// Other projects exports would go here